import styled from 'styled-components'
import { SearchLocationDistance as SearchLocationDistanceComponent } from 'components/atoms'

export const GeneralLocation = styled.div`
  padding-bottom: 20px;

  .accessibility-list {
    list-style: none;

    @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
      padding-top: 10px;
      padding-left: 0;
    }
  }

  .accessibility-list-item {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    color: ${ (props) => props.theme.colors['icon-grau1'] };

    span {
      margin-right: 10px;
    }

    p {
      margin: 0;
    }

    .search-location-distance {
      margin-left: 20px;
      font-size: 16px;
      line-height: 21px;
      font-weight: 200;

      svg {
        margin-right: 10px;
        stroke: black;
        stroke-width: 0.3px;

        path {
          fill: ${ (props) => props.theme.colors['icon-grau1'] };
        }
      }
    }
  }

  .accessibility-address {
    margin-top: 30px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;

    @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
      padding-left: 0;
    }

    .accessibility-address-title {
      font-weight: 800;
    }

    span {
      margin: 3px 0;
    }
  }

  .area-served {
    margin-top: 30px;
    padding-left: 20px;
    display: flex;
    flex-direction: column;

    .area-served-title {
      font-weight: 800;
    }

    span {
      margin: 3px 0;
    }
  }

  // tmp fix
  button {
    svg {
      position: relative;
      top: -2px;
      left: 10px;
      fill: ${ (props) => props.theme.colors['panel-inner-border'] } !important;
    }
  }
`

export const SearchLocationDistance = styled(SearchLocationDistanceComponent)`
  margin-left: 0;
  margin-right: 0;
`
